// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PauseOutlineSvg from '@rsuite/icon-font/lib/av/PauseOutline';
var PauseOutline = createSvgIcon({
  as: PauseOutlineSvg,
  ariaLabel: 'pause outline',
  category: 'av',
  displayName: 'PauseOutline'
});
export default PauseOutline;